export enum ShipmentType {
    HEAVY = 'HEAVY',
    LIGHT = 'LIGHT',
    APPAREL = 'APPAREL',
}